import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import { buildURLForCategory, buildURLForMenuItem } from "../../utils/buildURL";
import Link from "../../utils/Link";
import Features from "../Features";

const FeatureCard = (item) => {
  let head = [];
  if (item.head) {
    head = item.head;
  } else if (item.article && item.article.head) {
    head = item.article.head;
  }
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  const { ref, parentCategory, blockMode } = item;
  const { cover, title, feature, main, excerpt: description, button, slug } =
    item.article || item.category || item;

  let url = "";

  if (blockMode) {
    url = buildURLForMenuItem(item);
  } else {
    url = `${buildURLForCategory(parentCategory)}/${slug}`;
  }

  const features = useMemo(() => {
    if (Array.isArray(head)) {
      const f = head.filter(
        (i) => i.__typename === "API_ComponentArticlePatternBodyFeatureIcons"
      );

      if (f.length > 0) {
        return f[0].Icon;
      }
    }

    return [];
  }, []);

  return (
    <div
      className={`accounts-row__item accounts-row__item${
        main && "--highlighted"
      } filterable-item`}
    >
      <Link to={url} className="accounts-row__link">
        <div className="accounts-row__inner">
          <div className="accounts-row__preview">
            {cover && <img src={cover.url} alt={text(title, userLanguage)} />}
          </div>
          <div className="accounts-row__text">
            <div className="accounts-row__title">
              <font>
                <font>{text(title, userLanguage)}</font>
              </font>
            </div>
            {/* {description && description.text_sq && (
              <div
                dangerouslySetInnerHTML={{
                  __html: text(description, userLanguage)
                    .split("\n")
                    .join("</br>"),
                }}
              ></div>
            )} */}
            {(feature || Boolean(features.length)) && (
              <Features
                data={features.length ? features : feature.Icon}
                wrapperProps={{ horizontal: true, fullWidth: true }}
              />
            )}
            {button && (
              <p className="mt-3">
                <span className="button button--i-right">
                  <font>
                    <font>{t("plainCard.buttonText.text")}</font>
                  </font>
                  <i className="i-arrow-circle-right"></i>
                </span>
              </p>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default FeatureCard;
